const STORAGE_KEY = 'uiVersion';

export default {
	namespaced: true,
	state: {
		version: parseInt(localStorage.getItem(STORAGE_KEY)) || 1,
	},
	mutations: {
		setVersion(state, version) {
			state.version = version;
			localStorage.setItem(STORAGE_KEY, String(version));
		},
	},
	getters: {
		isV2: state => state.version === 2,
	},
};
